module.exports = __webpack_public_path__ + "media/topSection/5-e04a3d28.png";